import _                                                                 from 'underscore';
import React, { FC, ReactNode }                                          from 'react';
import { CorvalUIColor, FlexAlign, FlexJustify, Position, Size, ZIndex } from '../../types';
import { Container, ContainerProps }                                     from 'semantic-ui-react';
import { Flexbox }                                                       from './Flexbox';
import { FlexItem }                                                      from './FlexItem';
import { StyledContainer, StyledContainerProps }                         from './StyledContainer';
import { getCSSVar }                                                     from '../../util/BrowserUtility';
import { useUIDisplayModes } from '../../hooks';
import { Cell, Grid }        from "styled-css-grid";


export interface BottomProgressionNavBarProps {
    zIndex?: ZIndex,
    leftComponent?: ReactNode,
    centerComponent?: ReactNode,
    rightComponent?: ReactNode,
    contained?: boolean,
    bottomOffset?: number,
    outerContainerProps?: StyledContainerProps,
    innerContainerProps?: ContainerProps,

    [ additionalProps: string ]: any
}

const defaultProps: BottomProgressionNavBarProps = {
    zIndex:              5000,
    leftComponent:       null,
    centerComponent:     null,
    rightComponent:      null,
    contained:           true,
    bottomOffset:        null,
    outerContainerProps: {},
    innerContainerProps: {},
}

const BottomProgressionNavBar: FC<BottomProgressionNavBarProps> = ( props ) => {

    let { minimizedChrome } = useUIDisplayModes(),
        ContainerTag        = props.contained ? Container : React.Fragment,
        bottomOffset        = !( _.isNull( props.bottomOffset ) || _.isUndefined( props.bottomOffset ) )
                              ? props.bottomOffset
                              : minimizedChrome ? 0 : getCSSVar( '--layout-frame--footer-height' );

    return (

        <StyledContainer
            position={ Position.FIXED }
            zIndex={ props.zIndex }
            padding={ Size.MD }
            bgColor={ CorvalUIColor.LUNAR }
            left
            right
            bottom={ parseInt( bottomOffset ) }
            className={ 'container--shadowed-dk-blur-subtle border-sm-top border--colored-dk-screen-10' }
            { ...props.outerContainerProps }>

            <ContainerTag { ...props.innerContainerProps }>

                { props.children ?? (

                    <Grid columns={ `1fr minmax(250px,1fr) 1fr` } columnGap={ '20px' } className={ 'padding-lg-horizontal margin-md-horizontal' }>

                        <Cell middle>

                            { props.leftComponent }

                        </Cell>

                        <Cell middle>

                            { props.centerComponent }

                        </Cell>

                        <Cell middle>

                            <Flexbox justify={ FlexJustify.END } className={ 'max-width' }>
                                <FlexItem noGrow>

                                    { props.rightComponent }

                                </FlexItem>
                            </Flexbox>

                        </Cell>

                    </Grid>

                ) }

            </ContainerTag>

        </StyledContainer>
    );
};

BottomProgressionNavBar.defaultProps = defaultProps;

export { BottomProgressionNavBar }
